export default __webpack_public_path__ + "static/leftPhone-3557afac1c21f91771e0d236e8e1d455.png";